import { render, staticRenderFns } from "./AddAdditionalVisitors.vue?vue&type=template&id=6488efa0&"
import script from "./AddAdditionalVisitors.vue?vue&type=script&lang=js&"
export * from "./AddAdditionalVisitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports